import { OptionType } from '@evinced-private/ui-common';

import { getUniqueValues } from 'src/common/helpers/ArraysHelper';

import { MobileAppIdFilterOptionsQuery } from '../MobileAppIdFilterOptions.generated';

export interface IMobileAppIdFilterOptions {
	appId: OptionType[];
}

const naturalSort = (a: string, b: string): number =>
	a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });

const toSortedOptions = (values: string[]): OptionType[] =>
	values
		.reduce<OptionType[]>((acc, v) => {
			if (v) {
				acc.push({ value: v, label: v });
			}
			return acc;
		}, [])
		.sort((a, b) => naturalSort(String(a.value), String(b.value)));

export const transformMobileAppIdFilterOptionsResults = (
	raw: MobileAppIdFilterOptionsQuery
): IMobileAppIdFilterOptions => {
	const msdkIds = (raw.msdkApps ?? [])
		.filter(Boolean)
		.map((row) => row?.app_id)
		.filter(Boolean) as string[];

	return { appId: toSortedOptions(getUniqueValues(msdkIds)) };
};
